import { textFormatting } from '@yola/ws-sdk';

const {
  wrappersTypes: { decoration },
} = textFormatting.constants;

const forceRestyleDecorationTags = (parentElement) => {
  const decorationElements = parentElement.querySelectorAll(decoration.tagName);

  decorationElements.forEach((decorationElement) => {
    if (decorationElement.hasAttribute('style')) {
      decorationElement.hardSetInlineDecorationStyles();
    }
  });
};

export default forceRestyleDecorationTags;
